import React, { useState, useContext, createContext, useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Register } from "./Register";
import { SearchRegister } from "./SearchRegister";
import { Requerimento } from "./Requerimento";
import { CensoEscolar } from "./CensoEscolar";
import { AnaliseEstatistica } from "./AnaliseEstatistica";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { staffCanAccessMenu } from "../../config/menuAccessCatalog";

export const DataContext = createContext();

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export function RegisterTabs() {
  const [value, setValue] = useState(0);
  const [showStatsTab, setShowStatsTab] = useState(false);
  const [sharedData, setSharedData] = useState({
    matriculas: [],
    alunosById: {},
    responsavelByAlunoId: {},
    financeiroByContratoId: {},
    financeiroDerivadoByContratoId: {},
  });

  const isMobile = window.innerWidth <= 600;
  const { user } = useContext(AuthContext);

  const navigateToStats = useCallback(
    (data) => {
      setSharedData(data);
      let idx = 0;
      if (staffCanAccessMenu(user, "register_requerimento")) idx++;
      if (staffCanAccessMenu(user, "register_matricular")) idx++;
      if (staffCanAccessMenu(user, "register_consultar")) idx++;
      if (staffCanAccessMenu(user, "register_censo")) idx++;
      setValue(idx);
      setShowStatsTab(true);
    },
    [user]
  );

  const tabs = useMemo(() => {
    const out = [];
    if (staffCanAccessMenu(user, "register_requerimento")) {
      out.push({ id: "req", label: "Requerimento", element: <Requerimento /> });
    }
    if (staffCanAccessMenu(user, "register_matricular")) {
      out.push({ id: "mat", label: "Matricular", element: <Register /> });
    }
    if (staffCanAccessMenu(user, "register_consultar")) {
      out.push({ id: "con", label: "Consultar", element: <SearchRegister /> });
    }
    if (staffCanAccessMenu(user, "register_censo")) {
      out.push({
        id: "censo",
        label: "Relatório de Matrículas",
        element: <CensoEscolar onNavigateToStats={navigateToStats} />,
      });
    }
    if (showStatsTab && staffCanAccessMenu(user, "register_censo")) {
      out.push({
        id: "stats",
        label: "Análise Estatística",
        element: <AnaliseEstatistica data={sharedData} />,
      });
    }
    return out;
  }, [user, showStatsTab, sharedData, navigateToStats]);

  React.useEffect(() => {
    setValue((v) => (tabs.length && v >= tabs.length ? Math.max(0, tabs.length - 1) : v));
  }, [tabs.length]);

  if (!staffCanAccessMenu(user, "registration")) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="h6" color="error">
          Acesso negado a esta área.
        </Typography>
      </Box>
    );
  }

  if (!tabs.length) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="body1" color="text.secondary">
          Nenhuma aba de matrículas disponível para o seu usuário. Peça ao administrador para revisar as permissões de menu.
        </Typography>
      </Box>
    );
  }

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Matrículas"
          variant={isMobile ? "scrollable" : "standard"}
          scrollButtons={isMobile ? "auto" : false}
          allowScrollButtonsMobile={isMobile}
          centered
        >
          {tabs.map((t, idx) => (
            <Tab key={t.id} label={t.label} {...a11yProps(idx)} />
          ))}
        </Tabs>
      </Box>
      {tabs.map((t, idx) => (
        <TabPanel key={t.id} value={value} index={idx}>
          {t.element}
        </TabPanel>
      ))}
    </Box>
  );
}
